import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { InputPercent } from '~/components/NovosInputs';
import { useClassificacaoIbsCbs } from '../../hooks/useClassificacaoIbsCbs';
import Separator from '~/components/Separator';

export const FormCBS: React.FC = () => {
  const {
    formClassificao: { register, control, errors },
  } = useClassificacaoIbsCbs();
  return (
    <>
      <Row>
        <Col md={12}>
          <Separator labelText="CBS" />
        </Col>
      </Row>
      <Row className="gx-4">
        <Col xs="auto">
          <InputPercent
            name="per_aliq_cbs"
            label="Alíquota *"
            placeholder="0,00"
            maxLength={6}
            max={100}
            min={0}
            register={register}
            control={control}
            isError={!!errors.per_aliq_cbs}
          />
        </Col>
        <Col xs="auto">
          <InputPercent
            name="per_red_cbs"
            label="Redução *"
            placeholder="0,00"
            maxLength={6}
            max={100}
            min={0}
            register={register}
            control={control}
            isError={!!errors.per_red_cbs}
          />
        </Col>
        <Col xs="auto">
          <InputPercent
            label="Redutor Social *"
            name="val_red_social"
            placeholder="0,00"
            maxLength={6}
            max={100}
            min={0}
            register={register}
            control={control}
            isError={!!errors.val_red_social}
          />
        </Col>
      </Row>
    </>
  );
};
